// extracted by mini-css-extract-plugin
export var copy = "profile-module--copy--42069";
export var desktopBack = "profile-module--desktop-back--22146";
export var hero = "profile-module--hero--de4bb";
export var layout = "profile-module--layout--029bf";
export var left = "profile-module--left--7657c";
export var menu = "profile-module--menu--ff7fd";
export var mobileBack = "profile-module--mobile-back--ac701";
export var page = "profile-module--page--96c0b";
export var section = "profile-module--section--eb074";